/**
 * 平台通知「查看」带入的定位参数（SKC / SPU / 订单号等）。
 */

export function readNoticeProductQuery(searchParams) {
  if (!searchParams) return null;
  const q = String(searchParams.get('q') || '').trim();
  const skc = String(searchParams.get('skc') || '').trim();
  const spu = String(searchParams.get('spu') || '').trim();
  const idTypeRaw = String(searchParams.get('idType') || '').trim().toLowerCase();
  const dimRaw = String(searchParams.get('dim') || '').trim();
  const dim = dimRaw === 'listed' || dimRaw === 'pending' || dimRaw === 'sold_out' || dimRaw === 'offline'
    ? dimRaw
    : (q || skc || spu ? 'all' : '');
  if (q) {
    const idType = idTypeRaw === 'spu' || idTypeRaw === 'sku' ? idTypeRaw : 'skc';
    return { idType, keywords: q, dim: dim || 'all' };
  }
  if (skc) return { idType: 'skc', keywords: skc, dim: dim || 'all' };
  if (spu) return { idType: 'spu', keywords: spu, dim: dim || 'all' };
  return null;
}

export function readNoticeOrderNo(searchParams) {
  const v = String(searchParams?.get('orderNo') || '').trim();
  return v || '';
}

export function readNoticeReturnOrderNo(searchParams) {
  const v = String(searchParams?.get('returnOrderNo') || '').trim();
  return v || '';
}

export function readNoticeSkc(searchParams) {
  const v = String(searchParams?.get('skc') || '').trim();
  return v || '';
}
